var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPostTypes1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_252_147)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M448 94.2507V42.6667H490.667C502.443 42.6667 512 33.1093 512 21.3333C512 9.55733 502.443 0 490.667 0H106.667C47.8507 0 0 47.8507 0 106.667V490.667C0 502.443 9.55733 512 21.3333 512C33.1093 512 42.6667 502.443 42.6667 490.667V106.667C42.6667 71.3813 71.3813 42.6667 106.667 42.6667H149.333V94.2507C111.701 110.741 85.3333 148.352 85.3333 192V320C85.3333 378.816 133.184 426.667 192 426.667H405.333C464.149 426.667 512 378.816 512 320V192C512 148.352 485.632 110.741 448 94.2507ZM192 42.6667H405.333V85.3333H192V42.6667Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_252_147"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 512,
    height: 512,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPostTypes1);
export default __webpack_public_path__ + "static/media/Post Types 1.bea33db71b2b543ed4add7e8b12f71af.svg";
export { ForwardRef as ReactComponent };